import { Box, Typography } from '@mui/material'

// Do not show a guessed default value (especially an unchecked switch) for a value we cannot decode.
export default function UnavailableFieldRow({ label, caption, message }: { label: string; caption: string; message: string }) {
    return (
        <Box className="configuration-row">
            <Box>
                <Typography variant="body1">{label}</Typography>
                <Typography variant="caption">{caption}</Typography>
                <Typography variant="body2" color="text.secondary">
                    {message}
                </Typography>
            </Box>
        </Box>
    )
}
